// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-comfy -> weidner-apartment-homes-theme-comfy -> acacia-park
// Generated: 2026-11-02T18:12:31.066Z
// Counts: 0 design, 38 content, 22 slot group, 1 collection binding, 7 section, 0 style

export const designOverrides = {};

export const contentOverrides = {
  "accessibility-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Accessibility</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Amenities</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Apply Now</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_primary_color"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "left-lower",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Contact Us</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.hours_label": {
    "overrideType": "VALUE",
    "customValue": "<h2>Office Hours</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.office_label": {
    "overrideType": "VALUE",
    "customValue": "<h2>Leasing Office</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.talk_label": {
    "overrideType": "VALUE",
    "customValue": "<h2>Let's Talk</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "faq-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Frequently Asked Questions</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Floor Plans</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Designed for Your Lifestyle</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Gallery</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Welcome To <span data-type=\"field-token\" data-field=\"property_name\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactive-map-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Interactive Map</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Neighborhood</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodsection.heading": {
    "overrideType": "VALUE",
    "customValue": "<p>Northwest Odessa - Connected to It All</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Pet Policy</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.restrictions_heading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Pet Restrictions</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.welcome_text": {
    "overrideType": "VALUE",
    "customValue": "<h3>Dogs &amp; Cats Welcome</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacy-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Privacy Policy</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Welcome to Odessa Living</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "resident-access-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Resident Access</h1><h1></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviews-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Reviews</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Schedule A Tour</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemap-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Sitemap</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Virtual Tour</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "rentgrata-widget.property_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_rentgrata_token"
  },
  "amenities-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Acacia Park Apartment Homes in Odessa, TX, bring comfort right to your door with amenity-rich spaces. Experience modern living with granite kitchen countertops, central AC and heating, and your own patio or balcony. Step outside to enjoy the community's vibrant amenities, including a sparkling pool, clubhouse, courtyard, and business center. Our pet-friendly community ensures there's something for everyone, whether you're relaxing at home or spending time with friends and neighbors.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Our leasing team at Acacia Park Apartment Homes in Odessa, TX, is here to assist with your apartment search. Contact us to learn more about available floor plans, schedule a tour, or get answers to your rental questions.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Step into comfort with our one- and two-bedroom apartments for rent in Odessa, TX. Each layout features open living areas, large closets for extra storage, and inviting touches like granite kitchen countertops. Patios and balconies create breezy retreats perfect for morning coffee or unwinding after work. Plenty of flexible space lets you work, entertain, and relax your way.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Choose from one- and two-bedroom floor plans in Odessa</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Picture your next home at Acacia Park in Odessa, TX. Explore our gallery to see sunlit living rooms, sleek granite kitchens, and spacious patios or balconies. Take a peek at the sparkling pool, inviting clubhouse, and other resident favorites that showcase the community's warm, welcoming vibe. Ready to see more? Schedule a tour or check out our virtual options for a closer look.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Live close to it all at Acacia Park Apartment Homes in Odessa, TX. With easy access to SE Loop 338 and E-Business Loop 20, you're just minutes from exciting attractions like the University of Texas Permian Basin and Ellen Noel Art Museum. Enjoy local flavors at Pho House Odessa or Jock Jordan's Bar-B-Que, shop at Music City Mall, or catch a show at the MCM Events Center. Proximity to major employers like Halliburton makes getting to work easy, and you're never far from Odessa's thriving arts, dining, and entertainment scene.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodsection.body": {
    "overrideType": "VALUE",
    "customValue": "<p>At Acacia Park Apartment Homes, you're surrounded by Odessa's energy. Live near shops, music, art, and the University of Texas Permian Basin. Grab a bite at Jock Jordan's Bar-B-Que, browse the Music City Mall, or enjoy events at MCM Events Center. Quick access to University Blvd and JBS Parkway keeps work, school, and fun within easy reach. Make yourself at home in a lively, growing part of Odessa.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Come home to Acacia Park Apartment Homes and settle into a space that matches your lifestyle. Choose from comfortable one- and two-bedroom apartments for rent in Odessa, TX, perfect for relaxing evenings and weekends. Each apartment is designed with thoughtful upgrades like granite countertops, updated appliances, and vinyl flooring. Enjoy community spaces, including a sparkling pool and business center. With pet-friendly homes and flexible lease terms, Acacia Park is your place to unwind between adventures.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover Acacia Park Apartments your way. Schedule a private in-person tour to see our spacious apartments and inviting community spaces, including a built-in office and pool. Prefer to see more from home? Book a live virtual tour or explore our online gallery. Choose the tour style that works best for you, in person or online, and see what makes Acacia Park a comfortable Odessa retreat.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>See what life at Acacia Park Apartment Homes in Odessa, TX, feels like without leaving your seat. Our virtual tour takes you inside our apartments and around community spaces, giving you the full Odessa experience online. Explore layouts, picture your furniture, and soak up the community vibe, all at your pace, wherever you are. Use our scheduling tool to book a personal web tour, or drop in anytime to browse.</p>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "contactform.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "header.apply_now_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "FIELD_MAPPING",
        "customValue": "/apply-now",
        "mappedField": "property_apply_now_url"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_blank"
      }
    }
  },
  "hero.feature_slide_3": {
    "sourceIndex": 23,
    "fieldOverrides": null
  },
  "footer.get_in_touch_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/contact-us"
      }
    }
  },
  "header.resident_access_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "FIELD_MAPPING",
        "mappedField": "property_resident_portal_url"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_blank"
      }
    }
  },
  "contact-hero.bg_image": {
    "sourceIndex": 8,
    "fieldOverrides": null
  },
  "floor-plans-hero.bg_image": {
    "sourceIndex": 3,
    "fieldOverrides": null
  },
  "footer.managed_by_logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d270e-c548-748f-97de-b042810ed358.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Weidner Apartment Homes logo"
      }
    }
  },
  "gallery-hero.bg_image": {
    "sourceIndex": 11,
    "fieldOverrides": null
  },
  "hero.feature_slide_1": {
    "sourceIndex": 17,
    "fieldOverrides": null
  },
  "hero.feature_slide_2": {
    "sourceIndex": 0,
    "fieldOverrides": null
  },
  "hero.feature_slide_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/019d021a-176a-77d8-9d37-853132775783.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Lobby seating area with chairs and a coffee table, overlooking the pool."
      }
    }
  },
  "hero.feature_slide_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/019d021a-06a6-70da-a9fb-3eacb89bf3a2.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Kitchen with light wood cabinets, granite countertops, and black appliances."
      }
    }
  },
  "neighborhood-hero.bg_image": {
    "sourceIndex": 12,
    "fieldOverrides": null
  },
  "propertyoverview.card1_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/019d021a-119e-739f-8289-0d2cdaf3f57b.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Living room and kitchen area of an apartment with a white sofa, coffee table, TV, and wooden cabinets."
      }
    }
  },
  "propertyoverview.card2_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/019d0219-f823-72ee-bdba-9cb4590f5872.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Clubhouse lobby with seating area and conference table."
      }
    }
  },
  "propertyoverview.card3_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/019d0219-fb4a-72ee-a492-e37d4c5ae2df.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Community courtyard with benches and landscaping."
      }
    }
  },
  "residentaccess.payrent_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/019d0219-ebc2-717a-b38a-c8b1b6869dd2.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Kitchen with wooden cabinets, granite countertops, black appliances, and hardwood floors."
      }
    }
  },
  "residentaccess.portal_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/019d0219-ebc6-75de-8ec3-5a5974150e0c.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Comfortable bedroom with a queen-size bed, nightstands, and a dresser."
      }
    }
  },
  "residentaccess.service_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167164/019d0219-ddbc-76ad-8524-8dc214851f8a.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Living room with a sofa, coffee table, and TV."
      }
    }
  },
  "schedule-tour-hero.bg_image": {
    "sourceIndex": 18,
    "fieldOverrides": null
  },
  "virtual-tour-hero.bg_image": {
    "sourceIndex": 16,
    "fieldOverrides": null
  }
};

export const collectionBindingOverrides = {
  "photogallery.images": {
    "limit": null,
    "hiddenIds": [
      "ec_dfb8ffd9a594decfa3f4b837",
      "ec_803f1376181225b7941158c2",
      "ec_2e714d35a8175a02517e559a"
    ],
    "orderedIds": [
      "ec_2e914f97184b47ae6b1b4152",
      "ec_a3b684d08237e923a235f69f",
      "ec_89615f02c47e78a97c0646c4",
      "ec_13f1653eebb10e37c8ad405b",
      "ec_05ffcb56c749838952de0609",
      "ec_dfb8ffd9a594decfa3f4b837",
      "ec_e1e842330f720a49c3aec0a0",
      "ec_803f1376181225b7941158c2",
      "ec_5b1db70876bb57571020ae8d",
      "ec_bb934fc678ebce0f37812e2b",
      "ec_4dfedb598458a7d369dbf59b",
      "ec_ad3440cd029cbbcd41f2f8f3",
      "ec_ff501166f73a23e4d2025df0",
      "ec_c323c6ed00a2420c144677b7",
      "ec_a194ca72be8d44318dd6e617",
      "ec_d407b4d93e72088e9dd6b0b7",
      "ec_214f4b637ce7dd0786fe7dbf",
      "ec_833f94db67e30573c747171c",
      "ec_496562ba232d593a7b68b5cf",
      "ec_776454828ed54bf44fd0a1a4",
      "ec_2e714d35a8175a02517e559a"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  }
};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "apartment-sync-loader",
      "blockId": "apartment-sync-loader",
      "position": 0
    },
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "rentcafe-chatbot",
      "blockId": "rentcafe-chatbot",
      "position": 0
    },
    {
      "sectionId": "rentgrata-widget",
      "blockId": "rentgrata-widget",
      "position": 0
    }
  ]
};

export const styleOverrides = {};
